import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth.js'
import coreRoutes from '@/router/coreRoutes.js'

function loadPackageRoutes () {
  // The path is relative from *this file* (index.js)
  const packageModules = import.meta.glob(
    '../../../packages/*/*/resources/js/router/routes.js',
    { eager: true } // 'eager: true' loads them immediately
  )

  // Flatten the modules' default exports into a single array
  return Object.values(packageModules).flatMap(module => module.default)
}

const packageRoutes = loadPackageRoutes()
const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...coreRoutes,
    ...packageRoutes
  ]
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  // 1. Authentication Check (Existing)
  if (to.meta.requiresAuth && !authStore.currentUser) {
    return next({ name: 'Login' })
  }

  // 2. Authorization / Permission Check (New)
  if (to.meta.permission) {
    // Assuming your authStore has a helper like hasPermission()
    // or checks against an array like authStore.currentUser.permissions
    if (!authStore.hasPermission(to.meta.permission)) {
      return next({ name: 'Forbidden' }) // Or redirect to Home with error
    }
  }

  // 3. Guest Check (Existing)
  if (to.meta.isGuest && authStore.currentUser) {
    return next({ name: 'Home' })
  }

  next()
})

export default router
